interface YearlyTrend {
    [date: string]: number;
}

export const DATA_TYPES = {
    COMPETITORS: "Competitors",
    PAGES: "Pages",
} as const;

export type DataType = (typeof DATA_TYPES)[keyof typeof DATA_TYPES];

interface IResponseDataBase {
    Favicon: string;
    Clicks: number;
    OrganicShare: number;
    PaidShare: number;
    YearlyTrend: YearlyTrend;
}

interface IResponseDataCompetitor extends IResponseDataBase {
    Domain: string;
}

interface IResponseDataPage extends IResponseDataBase {
    Url: string;
}

export interface ITopCompetitorsResponseData {
    [DATA_TYPES.COMPETITORS]?: IResponseDataCompetitor[];
    [DATA_TYPES.PAGES]?: IResponseDataPage[];
}

type ICompetitor = Omit<IResponseDataCompetitor, "OrganicShare" | "PaidShare"> & {
    Organic: number;
    Paid: number;
};

export interface ITopCompetitorsTableData {
    Data: ICompetitor[];
}
